// ============================================================================
// Form Config: Queues
// Key: queues
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import type { FormSection } from '@/shared/forms/GenericForm'
import { enumFormOptions } from '../../entity-config-runtime/entity-form-config'
import { MediaType } from '../api/backstage.schemas'
// #endregion

// #region Create Form
export const queuesCreateFormConfig: FormSection[] = [
	{
		title: 'forms_queues_create_section_main',
		fields: [
			{
				name: 'name',
				label: 'forms_queues_create_name',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'description',
				label: 'forms_queues_create_description',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'wrapUpTimeSeconds',
				label: 'forms_queues_create_wrap_up_time_seconds',
				type: 'number' as const,
				initialValue: 0,
			},
			{
				name: 'sortOrder',
				label: 'forms_queues_create_sort_order',
				type: 'number' as const,
				initialValue: 0,
			},
			{
				name: 'type',
				label: 'forms_queues_create_type',
				type: 'select' as const,
				options: enumFormOptions(MediaType, 'MediaType'),
				initialValue: '',
			},
		],
	},
]
// #endregion

// #region Edit Form
export const queuesEditFormConfig: FormSection[] = [
	{
		title: 'forms_queues_edit_section_main',
		fields: [
			{
				name: 'name',
				label: 'forms_queues_edit_name',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'description',
				label: 'forms_queues_edit_description',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'wrapUpTimeSeconds',
				label: 'forms_queues_edit_wrap_up_time_seconds',
				type: 'number' as const,
				initialValue: 0,
			},
			{
				name: 'sortOrder',
				label: 'forms_queues_edit_sort_order',
				type: 'number' as const,
				initialValue: 0,
			},
			{
				name: 'type',
				label: 'forms_queues_edit_type',
				type: 'select' as const,
				options: enumFormOptions(MediaType, 'MediaType'),
				initialValue: '',
			},
		],
	},
]
// #endregion

// #region Forms Config Export
export const queuesFormsConfig = {
	create: queuesCreateFormConfig,
	edit: queuesEditFormConfig,
} as const
// #endregion
